import {
  MEMBERS_FETCHING,
  FETCH_MEMBERS,
  FILTER_MEMBERS_BY_PATTERN,
  FIND_MEMBER,
  COUNT_MEMBER,
  FETCH_AUTO_ENROLLED,
} from '../actions/types'

const initialState = {
  items: [],
  filteredItems: [],
  total: 0,
  countedBySex: [],
  countedByLevel: [],
  isFetching: false,
  limit: 0,
  offset: 0,
  loader: '',
  autoEnrolled: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case MEMBERS_FETCHING:
      return { ...state, isFetching: true }

    case FETCH_MEMBERS:
      return {
        ...state,
        items: action.payload.items,
        filteredItems: action.payload.loaded,
        loader: action.payload.loader,
        isFetching: false,
      }

    case COUNT_MEMBER:
      return {
        ...state,
        ...action.payload,
      }

    case FETCH_AUTO_ENROLLED:
      return {
        ...state,
        autoEnrolled: action.payload,
      }

    case FIND_MEMBER:
      return {
        ...state,
        found: action.payload,
      }

    default:
      return state
  }
}
